import React, { useEffect } from 'react';
import { Box, GDSStyleObject } from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { EasyPlanContainerComponent } from '../easyPlan-container.component';
import { EASYPLAN_ASSET_KEYS } from '../../../types/easy-plan-asset.types';
import { EasyPlanAboutCardItemsContainer } from './easyPlan-about-card-items-container.component';
import useEasyPlanStore from '../../../store/easy-plan-store';

export function EasyPlanAboutComponent(props: any) {
  const { errorHandling } = props;
  const easyPlanResponse = useEasyPlanStore(
    (state: any) => state.easyPlanHomeInfo,
  );
  useEffect(() => {
    errorHandling(true);
  }, [errorHandling]);

  return (
    <EasyPlanContainerComponent
      image={useStaticAsset(EASYPLAN_ASSET_KEYS.ABOUT_ICON) as string}
      title={easyPlanResponse?.easyPlanHome?.about?.title}
      description={easyPlanResponse?.easyPlanHome?.about?.description}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            gap: '$one',
            width: '327px',
            paddingBottom: '$two',
            '@mobile': {
              paddingBottom: '110px',
            },
          } as GDSStyleObject
        }
        data-testid="easyPlanAbout"
      >
        {easyPlanResponse?.easyPlanHome?.about?.tileList?.length
          ? easyPlanResponse?.easyPlanHome?.about?.tileList.map((item: any) => (
              <EasyPlanAboutCardItemsContainer item={item} key={item.title} />
            ))
          : null}
      </Box>
    </EasyPlanContainerComponent>
  );
}
